<template>
  <div>
    <div
      v-for="(item, index) in variant_attrs"
      :key="'attribute' + item.name + index"
      class="all_attribute"
    >
      <label
        class="attrsbute_name"
        :for="'attribute' + item.name + index"
        >{{ item.name }} </label>
      <div v-if="variants.attrs !== undefined" class="attrsbute_select">
        <v-add-card-select
          :list="item.value"
          :type="attrs"
          :index="index"
          :selectattribute="selectattribute"
        ></v-add-card-select>


      </div>
    </div>
  </div>
</template>

<script>
import vAddCardSelect from "./addCardSelect.vue";
export default {
  props:["variant_attrs","attrs","selectattribute","variants"],
  data(){
    return{}
  },
  components: {
    vAddCardSelect,
  },
}
</script>

<style>

</style>